(function() {
    'use strict';

    angular
        .module('app')
        .controller('tsunRecommendController', tsunRecommendController);

    function tsunRecommendController(trainingInnerService, $location, modalService, commonService, activeType) {
        var vm = this;
        vm.carouselClick = carouselClick;
        vm.showImg = showImg;
        vm.showVedio = showVedio;
        vm.backList = backList;
        //==Main==
        init();
        //========
        function init() {
            dataInit();
            logicInit();
        }

        function dataInit() {
            vm.data = {
                carousel: [], //.......................熱門推薦取得原始資料
                carouselSelected: {}, //...............點選的熱門推薦
            };
            vm.view = {
                isMobile: modalService.isMobile(), //..是否為行動裝置
                pageLoading: false, //.................頁面讀取中
                pageLoaded: false, //..................頁面讀取完畢
                showCarousel: true, //.................顯示熱門推薦清單
                showEmbed: false, //...................顯示嵌入式內容
                recommendEmpty: false, //..............內容是否為空
                recommendEmptyType2: false, //.........內容為空時顯示熱門推薦訊息
                recommendEmptyType3: false, //.........內容為空時顯示微課程訊息
                isMulitiData: true, //.................是否有多筆資料(使用輪播樣式)
            };
        }

        function logicInit() {
            vm.view.pageLoading = true;
            return loadData().then(function() {
                if (vm.data.carousel.length < 1) {
                    vm.view.recommendEmpty = true;
                    vm.view.recommendEmptyType2 = (activeType === 2);
                    vm.view.recommendEmptyType3 = (activeType === 3);
                    if (!vm.view.recommendEmptyType2) {
                        //預設錯誤訊息為"熱門推薦類型"
                        vm.view.recommendEmptyType2 = (!vm.view.recommendEmptyType2 && !vm.view.recommendEmptyType3);
                    }
                }
         
                vm.view.pageLoading = false;
                vm.view.pageLoaded = true;

                // 不知道為什麼不會自動跑動，所以在觸發一次囉
                $('#myCarousel').carousel({
                    interval: 5000
                });
            });
        }

        function loadData() {
            return trainingInnerService.getCarousel(activeType).then(function(result) {
                vm.data.carousel = result;
                //console.log("vm.data.carousel:", vm.data.carousel);
                //console.log("carousel $index",$index);
                vm.view.isMulitiData = (result.length > 1);
            });
        }

        function viewChange(showArea) {
            vm.view.showCarousel = false;
            vm.view.showEmbed = false;

            switch (showArea) {
                case 'carousel':
                    vm.view.showCarousel = true;
                    break;
                case 'embed':
                    vm.view.showEmbed = true;
                    break;
                default:
                    break;
            }
        }

        function showImg(attachmentType) {
            return commonService.showImg(attachmentType);
        }

        function showVedio(attachmentType) {
            return commonService.showVedio(attachmentType);
        }

        function backList() {
            viewChange('carousel');
        }

        function carouselClick(carouselItem) {
            var newWindow;
            vm.data.carouselSelected = angular.copy(carouselItem);
            vm.data.carouselSelected.isUrl = false;
            vm.data.carouselSelected.url = vm.data.carouselSelected.url || "";
            if (vm.data.carouselSelected.url.length > 0) {
                vm.data.carouselSelected.isUrl = true;
            }
            switch (carouselItem.target) {
                case 2:
                    viewChange('embed');
                    break;
                case 3:
                    if (vm.data.carouselSelected.isUrl) {
                        window.location = vm.data.carouselSelected.url;
                        return;
                    } else {
                        sessionStorage.setItem('recommendHTML', vm.data.carouselSelected.activityContent);
                        $location.path('/tsu/recommendHTML');
                    }
                    break;
                case 1:
                    //開新視窗
                    newWindow = window.open('', '_blank');

                    if (vm.data.carouselSelected.isUrl) {
                        newWindow.location = vm.data.carouselSelected.url;
                    } else {
                        newWindow.document.write(vm.data.carouselSelected.activityContent);
                    }
                    newWindow.document.title = vm.data.carouselSelected.activityTitle;
                    commonService.setOneWindow(newWindow);
                    break;
                default:
                    newWindow = window.open('', '_blank');
                    if (vm.data.carouselSelected.isUrl) {
                        newWindow.location = vm.data.carouselSelected.url;
                    } else {
                        newWindow.document.write(vm.data.carouselSelected.activityContent);
                    }
                    newWindow.document.title = vm.data.carouselSelected.activityTitle;
                    commonService.setOneWindow(newWindow);
                    break;
            }
        }
    }
})();